import { DatePicker } from '@/shared/components'

type TrainingStartDateSectionProps = {
  trainingStartDate: string
  onTrainingStartDateChange: (value: string) => void
  calendarMinDate?: string
  calendarMaxDate?: string
  allowedDays: number[]
  availableStartDates: string[]
  unavailableStartDate?: string | null
  disabled?: boolean
  scheduleNotice: string
}

export function TrainingStartDateSection({
  trainingStartDate,
  onTrainingStartDateChange,
  calendarMinDate,
  calendarMaxDate,
  allowedDays,
  availableStartDates,
  unavailableStartDate,
  disabled = false,
  scheduleNotice
}: TrainingStartDateSectionProps) {
  return (
    <div>
      <div>
        <h3 className="mb-3 text-base font-bold text-gray-dark">
          Select Your Desired Training Start Date
        </h3>
      </div>

      <div className="max-w-md">
        <DatePicker
          value={trainingStartDate || ''}
          onChange={onTrainingStartDateChange}
          placeholder="Choose a date"
          min={calendarMinDate}
          max={calendarMaxDate}
          disablePast
          allowedDays={allowedDays}
          includedDates={availableStartDates.length > 0 ? availableStartDates : undefined}
          excludedDates={unavailableStartDate ? [unavailableStartDate] : []}
          disabled={disabled}
        />
        <p className="mt-2 text-sm leading-6 text-gray-light">{scheduleNotice}</p>
      </div>
    </div>
  )
}
